// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__4TDBa","light":"Layout_light__SPjSQ","dark":"Layout_dark__1UKGZ","main-content":"Layout_main-content__IBS7S"};